import React, { useEffect, useState } from "react";
import { BiExport } from "react-icons/bi";
import { MdClear } from "react-icons/md";
import { useQuery } from "react-query";
import {
  CampaignWiseReportApi,
  DownloadCampaignWiseReportApi,
  DownloadSMSConversionReportTwoApi,
  SMSConversionReportTwoApi,
  UserListApi,
} from "../../../Api";
import { AxiosResponse } from "axios";
import { RenderPaginationButtons } from "../../../../Components/Paginations";
import { useLocation, useNavigate } from "react-router-dom";
import { formatDate } from "../../../../helper";
import {
  BsFiletypeDoc,
  BsFiletypeDocx,
  BsFiletypePdf,
  BsFiletypeXls,
  BsFiletypeXlsx,
} from "react-icons/bs";
import { FaEnvelopeOpenText, FaFile, FaUserCircle } from "react-icons/fa";
import { Dropdown } from "react-bootstrap";
import { FiDownload } from "react-icons/fi";
import { DateFormat, isJSONString } from "../../Chatbox/ChatBox";
import { saveAs } from "file-saver";
import { IoMdArrowRoundBack } from "react-icons/io";
import ReactSelect from "react-select";
import BarLoader from "react-spinners/BarLoader";
import ImageModal from "../../../../Components/ImageModal";

interface ReportDataType {
  sender_id: number;
  createdAt: string;
  direction: string;
  error_code: number;
  error_message: string;
  from: string;
  id: number;
  media_url: string;
  message: string;
  message_type: string;
  retry_sms_id: number | null;
  sms_gateway_name: string;
  status: number;
  to: string;
  user: {
    name: string;
    email: string;
    role: number;
  } | null;
}

interface PropsType {
  CampaignID: number;
  SelectedNumber: string;
  selectedAgent: number | null;
}

export default function Chats({
  CampaignID,
  SelectedNumber,
  selectedAgent,
}: PropsType) {
  const [Data, setData] = useState<ReportDataType[]>([]);
  const { state } = useLocation();
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [showImage, setShowImage] = useState(false);
  const [image, setImage] = useState("");

  const Report = useQuery({
    queryKey: [
      "SMS-Conversion-2",
      { campaign_id: CampaignID, number: SelectedNumber, is_pagination: false },
      page,
      undefined,
    ],
    queryFn: SMSConversionReportTwoApi,
    onSuccess: (resp: AxiosResponse) => {
      setData(resp.data?.data || []);
      setPage(resp.data?.info?.current_page || 1);
      setIsLoading(false);
    },
    enabled: false,
  });

  const ReportDownload = useQuery({
    queryKey: [
      "SMS-Conversion-2-Download",
      { campaign_id: CampaignID, number: SelectedNumber },
      page,
    ],
    queryFn: DownloadSMSConversionReportTwoApi,
    onSuccess: (resp: AxiosResponse) => {
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(resp.data);
      link.download = `SMS_Conversion_Report_2_${new Date().toISOString()}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    enabled: false,
  });

  useEffect(() => {
    if (SelectedNumber && CampaignID) {
      setIsLoading(true);
      Report.refetch();
    } else {
      setData([]);
      setIsLoading(false);
    }

    // eslint-disable-next-line
  }, [SelectedNumber, CampaignID, page]);

  const downloadMedia = async (imgUrl: string) => {
    fetch(imgUrl)
      .then((response) => response.blob())
      .then((blob) => {
        saveAs(blob, imgUrl.split("/").pop());
      })
      .catch(() => {});
  };
  return (
    <>
      <ImageModal setShow={setShowImage} show={showImage} image={image} />

      <div
        className={`flex-column h-100 overflow-x-auto pt-0 ${
          isLoading ? "d-flex" : "d-none"
        }`}
      >
        <div className="d-flex justify-content-center align-items-center w-100 h-100">
          <div>
            <h5 className="text-center text-secondary fs-sm">
              Getting All message.
            </h5>
            <BarLoader
              className="rounded-5"
              height={6}
              color="rgba(61, 153, 112, 0.5)"
              width={250}
            />
          </div>
        </div>
      </div>
      <div className={`d-flex flex-column h-100 overflow-x-auto pt-0  d-flex`}>
        {!SelectedNumber ? (
          <div className="d-flex gap-2 flex-column h-100 bg-white justify-content-center align-items-center me-2">
            <FaEnvelopeOpenText size={45} className="text-secondary" />
            <h5 className="text-center text-secondary">Select a Number</h5>
          </div>
        ) : (
          <>
            <div
              className="input-group position-sticky top-0 w-100 d-flex justify-content-between flex-nowrap"
              style={{ background: "#d3d6de", zIndex: 999 }}
            >
              <div className="d-flex px-3 align-items-center flex-grow-1 flex-wrap">
                <div className="d-flex align-items-center">
                  <div className="d-flex align-items-center py-2">
                    <FaUserCircle size={28} />
                    <div className="px-md-2 px-1">
                      <p className="fw-bold fs-12 mb-0">{SelectedNumber}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex flex-column gap-3 px-3 flex-grow-1 position-relative">
              <div className="msg-box" id="ChatBox">
                {Data.map((item, i) => (
                  <div
                    className={`direct-chat-msg ${
                      item?.direction === "Outbound" ? "right" : ""
                    }`}
                    key={i}
                    id={`${i === Chats.length - 1 ? "newMsg" : ""}`}
                  >
                    <div className="direct-chat-infos clearfix">
                      {item?.user?.name ? (
                        <small className="direct-chat-name fs-10">
                          {item?.user?.name}
                        </small>
                      ) : null}
                    </div>
                    <div className="direct-chat-infos clearfix">
                      {item?.sender_id === null ? (
                        <small className="direct-chat-name">
                          From Broadcast
                        </small>
                      ) : null}
                    </div>
                    <div className="Message">
                      <div>
                        <div
                          className={`d-flex flex-wrap gap-2 px-3 ${
                            item?.direction === "Outbound"
                              ? "justify-content-end"
                              : ""
                          }`}
                          style={{ maxWidth: 348 }}
                        >
                          {isJSONString(item?.media_url) &&
                            JSON.parse(item?.media_url).map(
                              (
                                item: {
                                  media_url: string;
                                  content_type: string;
                                },
                                i: number
                              ) => {
                                if (item?.content_type?.startsWith("image/"))
                                  return (
                                    <div
                                      className="showImages bg-dark d-block"
                                      key={i}
                                    >
                                      <FiDownload
                                        color="black"
                                        className="my-1 removeImageBtn p-1"
                                        style={{ height: 25, width: 25 }}
                                        onClick={() =>
                                          downloadMedia(item?.media_url)
                                        }
                                      />
                                      <img
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                        }}
                                        src={item?.media_url}
                                        alt="img"
                                        className="shadow-none object-fit-contain cursor-pointer"
                                        onClick={() => {
                                          setImage(item?.media_url);
                                          setShowImage(true);
                                        }}
                                      />
                                    </div>
                                  );
                                else
                                  return (
                                    <div
                                      className={`showImages bg-dark overflow-hidden`}
                                      key={i}
                                    >
                                      <FiDownload
                                        color="black"
                                        className="my-1 removeImageBtn"
                                        onClick={() =>
                                          downloadMedia(item?.media_url)
                                        }
                                      />
                                      <div className="w-100 h-100 d-flex flex-column justify-content-between">
                                        <div className="d-flex flex-grow-1 justify-content-center align-items-center">
                                          {item?.content_type ===
                                          "application/vnd.ms-excel" ? (
                                            <BsFiletypeXls
                                              className="w-100 text-success"
                                              style={{ height: 35 }}
                                            />
                                          ) : item?.content_type ===
                                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? (
                                            <BsFiletypeXlsx
                                              className="w-100 text-success"
                                              style={{ height: 35 }}
                                            />
                                          ) : item?.content_type ===
                                            "application/msword" ? (
                                            <BsFiletypeDoc
                                              className="w-100 text-primary"
                                              style={{ height: 35 }}
                                            />
                                          ) : item?.content_type ===
                                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? (
                                            <BsFiletypeDocx
                                              className="w-100 text-primary"
                                              style={{ height: 35 }}
                                            />
                                          ) : item?.content_type ===
                                            "application/pdf" ? (
                                            <BsFiletypePdf
                                              className="w-100 text-danger"
                                              style={{ height: 35 }}
                                            />
                                          ) : (
                                            <FaFile
                                              className="w-100"
                                              style={{ height: 35 }}
                                            />
                                          )}
                                        </div>
                                        <p
                                          className="mb-2 fs-11 text-center"
                                          style={{ fontSize: 11 }}
                                        >
                                          {/* {item?.name} */}
                                        </p>
                                      </div>
                                    </div>
                                  );
                              }
                            )}
                        </div>
                        {isJSONString(item?.media_url) &&
                        JSON.parse(item?.media_url)?.length > 0 ? (
                          <small
                            className={`direct-chat-timestamp d-block mt-2 fs-10 px-3 text-dark ${
                              item?.direction === "Outbound" ? "text-end" : ""
                            }`}
                          >
                            {DateFormat(item?.createdAt)}
                          </small>
                        ) : null}
                        <div
                          className={`d-flex flex-column ${
                            item?.direction === "Outbound"
                              ? "align-items-end"
                              : ""
                          }`}
                        >
                          {item?.message ? (
                            <div
                              className={`direct-chat-text mx-4 fs-14 position-relative`}
                              style={{ width: "fit-content" }}
                            >
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item?.message?.replaceAll(
                                    /\n/g,
                                    "<br>"
                                  ),
                                }}
                              />
                              <small className="direct-chat-timestamp d-block mt-2 fs-10 text-end">
                                {DateFormat(item?.createdAt)}
                              </small>
                            </div>
                          ) : null}
                          {item.direction === "Outbound" ? (
                            <small
                              className={`me-3 direct-chat-timestamp fw-bold fs-10 d-block text-end ${
                                item?.status === 0 ||
                                item?.status === 5 ||
                                item?.status === 6
                                  ? "text-warning"
                                  : item?.status === 1
                                  ? "text-info"
                                  : item?.status === 4 ||
                                    item?.status === 7 ||
                                    item?.status === 3
                                  ? "text-danger"
                                  : "text-gray"
                              }`}
                            >
                              {item?.status === 0 ? (
                                "Pending"
                              ) : item?.status === 1 ? (
                                "Sent"
                              ) : item?.status === 2 ? (
                                "Delivered "
                              ) : item?.status === 3 ? (
                                "Undelivered"
                              ) : item?.status === 4 || item.status === 3 ? (
                                <>Failed</>
                              ) : item?.status === 5 ? (
                                "Delivery Unknown"
                              ) : item?.status === 6 ? (
                                "Delivery Unconfirmed"
                              ) : item?.status === 7 ? (
                                "Unknown Gateway"
                              ) : (
                                ""
                              )}
                            </small>
                          ) : null}
                        </div>
                      </div>
                      {item?.direction === "Outbound" ? (
                        <div className="direct-chat-img d-flex justify-content-center align-items-center bg-success mt-2 mt-lg-0">
                          {item?.sender_id === null
                            ? "B"
                            : item.user?.name.trim().charAt(0).toUpperCase()}
                        </div>
                      ) : (
                        <div className="direct-chat-img d-flex justify-content-center align-items-center bg-secondary mt-2 mt-lg-0">
                          <FaUserCircle className="h-100 w-100" />
                        </div>
                      )}
                    </div>
                  </div>
                ))}

                <div id="BottomDiv" />
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}
